import Vue from "vue"
import Router from "vue-router"
import axios from "./axios"
import store from "./store"

Vue.use(Router)

// lazy-loaded
function loadView(view) {
	return () =>
		import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}

const routerMode = process.env.NODE_ENV == 'development' ? 'hash' : 'history'

const router = new Router({
	base:"/CatFoodBowl-BattleofKirinS3/",
	mode: routerMode,
	routes: [
		{
			path: "/",
			name: "CatFoodBowl-BattleofKirinS3",
			component: loadView("index")
		}
	]
})

router.beforeEach(async (to, from, next) => {
	switch (to.name) {
		case "special":
			store.commit("SET_TOPNAVBTN_INDEX", 4);
			break;
		default:
			break;
	}

	if (to.meta.requiresAuth) {
		if (store.state.TOKEN) {
			await axios.get("/user/checkToken").then(v => {
				next()
			})
		} else {
			next({
				path: "/login",
				query: { redirect: to.fullPath }
			})
		}
	} else {
		next()
	}
})

export default router
